/*----- Core -----*/
import React              from 'react'
import { connect }        from "react-redux"

/*----- Utils -----*/
import ScrollTop from '../../utils/ScrollTop'

/*----- Assets -----*/
import logoNuestraCasa 	 from '../../assets/logo_nuestra_casa.svg'
import people     	     from '../../assets/home/people.png'
import producersVideo    from '../../assets/videos/productores.mp4'
import peopleWorking     from '../../assets/videos/people_working.mp4'
import PersonWithLines 	 from  '../../assets/images/home/person_with_lines.jpg'
import orangeCircle      from  '../../assets/home/orange_circle_and_lines.svg'


/*----- Components -----*/
import SectionContainer   from '../../components/commons/SectionContainer'
import DefaultButton      from '../../components/button/DefaultButton'
import Video 							from '../../components/Video'
import HeroParagraph 			from '../../components/hero/HeroParagraph'
import Paragraph 					from '../../components/text/Paragraph'

/*----- Styles -----*/
import Styles from './Styles'

/*----- Ant Design -----*/
import { Row, Col } from 'antd'

/*----- Export -----*/
const Home = (props) => {
	ScrollTop()
	return (
		<Styles>
			<Row className="wellcome">
				<div className="wellcome-content">
					<h1 className="wellcome-content__title">En sintonía con los productores</h1>
					<DefaultButton content="Conocenos" invert destination="/producers" />
				</div>
				<Video 
					videoUrl 		= { producersVideo }
					height   		= { 500 }
					coverColor  = 'rgba(47, 137, 252, 0.8)'
				/>
			</Row>
			<SectionContainer>
				<Row className="statement statement_1">
					<Col xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
						<div className="statement__image-container">
							<img src={ PersonWithLines } className="icon"  alt="persona con lineas decorativas"/>
						</div>
					</Col>
					<Col xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
						<div>
							<HeroParagraph
								title     = "Organización de productores de seguros"
								subtitle  = "Más de 25 años transitando el mercado de seguros, recorriendo oficinas, viviendo experiencias, enfrentando casos diversos y tratando con clientes de distintos rubros. Haber recorrido estos caminos, nos configura hoy como una organización de productores de seguros consolidada. Asesoramos a los productores y les brindamos asistencia para ampliar su cartera de clientes y mantenerse actualizados en cuanto a las novedades del mercado asegurador. Nuestro principal objetivo es que el equipo de productores que forma parte de la organización le brinde un servicio de calidad a sus asegurados."
							/>
						</div>
					</Col>
				</Row>
			</SectionContainer>
			<SectionContainer noSpacing>
				<Row className="statement statement_2" >
					<Col xs={24} sm={{span: 24}} md={{span: 18}} lg={{span: 18 }} xl={{span: 18 }}>
						<div>
							<HeroParagraph
								title     = "¿Cómo pensamos?"
								subtitle  = "Cada productor es igual de importante en la organización, sin importar su experiencia o su cartera de clientes, entender así la dinámica humana y de trabajo, nos permitió crecer y estos valores no los negociamos. Acompañamos a los más jóvenes en sus primeros pasos como profesionales del sector y potenciamos el crecimiento de los productores con experiencia con quienes trabajamos hace años. "
							/>
						</div>
					</Col>
					<img src={ orangeCircle } className="circle-and-lines" alt=""/>
				</Row>
			</SectionContainer>
			<SectionContainer>
				<Row className="statement statement_3">
					<Col xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
						<div className="group">
							<img src={ people } className="statement_3__people-image"  alt=""/>
							<DefaultButton content="Conocé a todos" destination="/producers" />
						</div>
					</Col>
					<Col xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
						<div>
							<HeroParagraph
								title     = "Más de 100 productores!"
								subtitle  = "El equipo de LB se encuentra conformado por más de 100 productores de seguros a quienes asesoramos, brindamos respaldo  y ofrecemos herramientas para hacer crecer su negocio. Nuestro objetivo es lograr que nuestros productores aumenten su cartera de clientes y les ofrezcan un servicio de excelencia a sus asegurados. En esta sección te invitamos a conocer a colegas que ya están creciendo de la mano de LB."
							/>
						</div>
					</Col>
				</Row>
			</SectionContainer>

			<Row className="home-sentence">
				<p>En nuestra organización el productor es nuestro cliente, por esta razón cada paso que damos, lo hacemos pensando en respaldar y potenciar el negocio de nuestra cartera de productores.</p>
			</Row>

			<Row className="our-home-video">
				<Video 
					videoUrl 		= { peopleWorking }
					height   		= { 400 }
					coverColor  = 'rgba(47, 137, 252, 0.8)'
				/>
			</Row>

			<SectionContainer>
				<Row className="nuestra-casa">
					<Col xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
						<HeroParagraph
							title       	= "Nuestra Casa, encuentro de productores"
							subtitle    	= "Contamos con una oficina física y una virtual donde los productores se pueden conectar de lunes a viernes para trabajar de manera remota y evacuar dudas. Además trabajamos con una lista de difusión de noticias para que nuestro equipo esté constantemente actualizado y pueda brindar un servicio de excelencia a sus clientes."
						/>
					</Col>
					<Col xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
						<div className="nuestra-casa__content">
							<img src={logoNuestraCasa} alt="logo nuestra casa" className="nuestra-casa__logo"/>
							<Paragraph bold content="En esta coyuntura donde no podemos asistir a nuestra oficina física, esta plataforma se convirtió en una gran aliada para conservar la eficacia del servicio que brindamos a nuestros productores."/>
							<DefaultButton content="Conocé el espacio" destination="/our-home" />
						</div>
					</Col>
				</Row>
			</SectionContainer>
			
	
		</Styles>
	)
}

function mapStateToProps(state) {
	return {}
}

function mapDispatchToProps(dispatch) {
	return {}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Home)